import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { map } from 'rxjs/operators';
import {User, Response} from '../models/user';
import {BehaviorSubject, Observable, of} from 'rxjs';
import {environment, isODM} from '../../environments/environment';
import {TOKEN, UtilsService} from './utils.service';
export const STORE_KEY_Redirect = 'RedirectTo';
@Injectable()
export class UserService {
  loginStatus = new BehaviorSubject<boolean>(false);
  currentUser = new BehaviorSubject<any>(null);
  redirect: string;
  constructor(private http: HttpClient, private utils: UtilsService) { }


  loginServer(loginData): Observable<Response> {
    const username = loginData.username.trim();
    const password = loginData.password.trim();
    return this.http.post<Response>('/api/auth/login', {
      Account: username,
      Password: password,
      isOdm: isODM,
      LoginType: 10,
    });
    // req note: LoginType = 10代表PowerPanel Web Login, 11代表PowerPanel Web Logout
  }
  logoutServer(otp): Observable<any> {
    return this.http.post<any>(`${environment.apiSerivceUrl}/Personal/api/Service/LogoutAccount`, { otp: otp, LoginType: 11});
  }

  UpgradPROSuccessLogout(otp) {
    return this.http.post(`${environment.apiSerivceUrl}/Personal/api/Service/LogoutAccount`, { otp: otp, LoginType: 11}); // or environment.apiBaseUrl + '/logout'
  }

  getCurrentUser(): Observable<User> {
    const token = JSON.parse(localStorage.getItem(TOKEN));
    if (token && token.value) {
      this.loginStatus.next(true);
      this.currentUser.next({
        username: token.username,
        OtpKey: token.value,
        acode: token.acode,
        RegionId: token.RegionId,
        Package: token.Package,
        authority: token.authority,
        IsMsp: token.IsMsp
      });
    }
    return this.currentUser;
  }

  set SetRedirect(value) {
    localStorage.setItem(STORE_KEY_Redirect, value);
    this.redirect = value;
  }

  get GetRedirect() {
    const data = localStorage.getItem(STORE_KEY_Redirect);
    return (data !== '') ? data : '/index';
  }
}

